// extracted by mini-css-extract-plugin
export default {"icon":"SelectV2_icon__bcspo"};